export default __webpack_public_path__ + "static/media/gtx1050ti.031a08f7.jpg";